import { useTranslation } from 'react-i18next';
import { type AdyenPaymentModuleSpecsFragment } from '../../../../../api/fragments/AdyenPaymentModuleSpecs';
import {
    CreateAdyenPaymentModuleDocument,
    type CreateAdyenPaymentModuleMutation,
    type CreateAdyenPaymentModuleMutationVariables,
} from '../../../../../api/mutations/createAdyenPaymentModule';
import { type AdyenPaymentModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import AdyenPaymentModulePage, { type AdyenPaymentModulePageProps } from '../../AdyenPaymentModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<AdyenPaymentModuleSpecsFragment, AdyenPaymentModuleSettings> = {
    PageComponent: ({ module }: AdyenPaymentModulePageProps) => <AdyenPaymentModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.AdyenPaymentModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateAdyenPaymentModuleMutation, CreateAdyenPaymentModuleMutationVariables>({
                mutation: CreateAdyenPaymentModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
